import type React from 'react'
import { SkeletonTable } from '@/components/skeleton-common'
import { Skeleton } from '@/components/ui/skeleton'

const AccountsPageSkeleton: React.FC = () => (
  <div className="flex flex-col h-screen w-full" data-testid="loading">
    <div className="flex-none bg-background w-full">
      <div className="container mx-auto p-6">
        <Skeleton className="h-8 w-32" />
      </div>
    </div>

    <div className="flex-1 overflow-auto p-6">
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <Skeleton className="h-8 w-64" />
          <div className="flex items-center gap-2">
            <Skeleton className="h-8 w-8" />
            <Skeleton className="h-8 w-24" />
          </div>
        </div>
        <SkeletonTable rows={15} columns={8} />
      </div>
    </div>
  </div>
)

export { AccountsPageSkeleton }
